import {RootModel} from "./index";
import {createModel} from "@rematch/core";
import {getAllDictTypes, getAllDicts, getCommonData} from "../apis/sysDict";

type BaseDataState = any;

const initState: BaseDataState = {}

export const baseData = createModel<RootModel>()({
    state: initState,
    reducers: {
        setBaseData: (state: BaseDataState, payload?: any) => ({...state, ...(payload ?? {})})
    },
    effects: (dispatch) => ({
        async getBaseData() {
            const data = (await getCommonData()).data.data ?? []
            data.dealerGroups = data.dealerGroups.map((i: any) => ({...i, value: `${i.value}(${i.extra})`}))
            dispatch.baseData.setBaseData(data)
        }
    })
});
